import UkFlag from "../assets/flags/united-kingdom.svg";
import SomFlag from "../assets/flags/somalia.svg";
import DjFlag from "../assets/flags/djibouti.svg";
import EtFlag from "../assets/flags/ethiopia.svg";
import UgFlag from "../assets/flags/uganda.svg";
import TzFlag from "../assets/flags/tanzania.svg";
import KeFlag from "../assets/flags/kenya-flag.png";
import UaeFlag from "../assets/flags/united-arab-emirates.svg";
import Rwanda from "../assets/flags/rwanda.svg";
import Ghana from "../assets/flags/ghana.svg";
import Nigeria from "../assets/flags/nigeria.svg";
import SouthAfrica from "../assets/flags/south-africa.svg";
import Egypt from "../assets/flags/egypt.svg";

const contryFlags = {
  UkFlag,
  SomFlag,
  DjFlag,
  EtFlag,
  UgFlag,
  TzFlag,
  KeFlag,
  UaeFlag,
  Rwanda,
  Ghana,
  Nigeria,
  SouthAfrica,
  Egypt,
};

export default contryFlags;
